export const formatSellingPlanName = (name: string) => {
  return name
    .toLowerCase()
    .replace(/^delivery /, '')
    .replace('every 1 month', 'every month')
    .replace(/with \d+% discount/, '')
}
